import type { ConnectorFamilyParameterTargetSelection } from './connectorPlan';
import type { ParameterAdditionOptions } from './models';

export type ConnectorFamilyTargetDisposition =
  | 'resolveBroadly'
  | 'mutate'
  | 'alreadySatisfied'
  | 'nonApplicable';

export function resolveConnectorFamilyTargetDisposition(input: {
  selection: ConnectorFamilyParameterTargetSelection;
  mutationTargetFamilyIds: string[];
  familyTargetMode?: ParameterAdditionOptions['familyTargetMode'];
}): ConnectorFamilyTargetDisposition {
  if (!input.selection.hasReliableSnapshot) {
    return 'resolveBroadly';
  }

  if (input.mutationTargetFamilyIds.length > 0) {
    return 'mutate';
  }

  if (input.familyTargetMode === 'newSincePreviousConnectorSetup' ||
      input.selection.matchingFamilyCount === 0) {
    return 'nonApplicable';
  }

  return input.selection.compatibleFamilyCount === input.selection.matchingFamilyCount
    ? 'alreadySatisfied'
    : 'nonApplicable';
}
